import React, { useEffect } from 'react';
import { FaTimes, FaCalendarCheck } from 'react-icons/fa';
import './Notification.css';

const Notification = ({ notification, onClose }) => {
  useEffect(() => {
    if (notification.autoClose !== false) {
      const timer = setTimeout(() => {
        onClose();
      }, notification.duration || 5000);
      return () => clearTimeout(timer);
    }
  }, [notification, onClose]);

  return (
    <div className={`notification ${notification.type || 'info'}`}>
      <div className="notification-icon">
        <FaCalendarCheck />
      </div>
      <div className="notification-content">
        <h4>{notification.title}</h4>
        <p>{notification.message}</p>
      </div>
      <button className="notification-close" onClick={onClose}>
        <FaTimes />
      </button>
    </div>
  );
};

export default Notification;

